import styled from 'styled-components';

export const Container = styled.div<{ width?: string }>`
  align-items: center;
  display: flex;
  gap: 8px;
  width: ${({ width }) => width || '320px'};
`;

export const InfoWrapper = styled.div`
  align-items: start;
  flex: 1;
`;

export const PublisherCardImage = styled.img``;

export const PublisherCardName = styled.h4`
  border-bottom: ${({ theme }) => theme.elsie.borderWidth.sm} solid
    ${({ theme }) => theme.elsie.colors.inverse.border.subtle};
  color: ${({ theme }) => theme.elsie.colors.inverse.content.accent};
  font-size: 20px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  letter-spacing: -0.32px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0 0 8px 0;
`;

export const PublisherCardRole = styled.h5`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.accent};
  font-size: ${({ theme }) => theme.elsie.fontSize.sm};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0 0 4px 0;
`;

export const PublisherCardSpecialty = styled.h6`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.subtle};
  font-size: ${({ theme }) => theme.elsie.fontSize.sm};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0;
`;
